
import React from 'react'

import ParamGroup from './ParamGroup'

const Component = ({
  endpoint,
  location,
  explorer,
  microcopy
}) => {
  const params = endpoint.params.filter(param => 
    param.location === location
  )

  return <ParamGroup
    params={params}
    explorer={explorer}
    location={location}
    microcopy={microcopy} />
}

export default Component